const isAppActive = () => !document.hidden;
export default isAppActive;
